"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerSlot = exports.RegionCodec = exports.TileCodec = exports.CollisionCodec = void 0;
const t = __importStar(require("io-ts"));
const Resource_1 = require("./Resource");
exports.CollisionCodec = t.union([
    t.boolean,
    t.type({
        top: t.union([t.boolean, t.tuple([t.boolean, t.boolean])]),
        left: t.union([t.boolean, t.tuple([t.boolean, t.boolean])]),
        bottom: t.union([t.boolean, t.tuple([t.boolean, t.boolean])]),
        right: t.union([t.boolean, t.tuple([t.boolean, t.boolean])]),
    }),
]);
exports.TileCodec = t.intersection([
    t.type({
        collision: exports.CollisionCodec,
    }),
    t.partial({
        zones: t.array(t.string),
        underPlayer: t.array(Resource_1.LayerRefCodec),
        overPlayer: t.array(Resource_1.LayerRefCodec),
    }),
]);
exports.RegionCodec = t.intersection([
    t.type({
        id: t.string,
        resources: t.array(t.string),
        width: t.number,
        height: t.number,
        map: t.array(t.array(exports.TileCodec)),
    }),
    t.partial({
        zones: t.string,
    }),
]);
var LayerSlot;
(function (LayerSlot) {
    LayerSlot["UnderPlayer"] = "underPlayer";
    LayerSlot["OverPlayer"] = "overPlayer";
})(LayerSlot = exports.LayerSlot || (exports.LayerSlot = {}));
//# sourceMappingURL=Region.js.map